import { RecordEdit } from "../record/recordEdit";
import { RecordEditItemLogListItems } from "../record/recordEditItemLogListItems";
import { RecordEditNew } from "../record/recordEditNew";
import { RecordExpiredFurtherEducationListItems } from "../record/recordExpiredFurtherEducationListItems";
import { RecordListItems } from "../record/recordListItems";
import { RecordPage } from "../record/recordPage";
import { RecordPageUnitsAndJobTitles } from "../record/recordPageUnitsAndJobTitles";
import { RecordEducationEdit } from "../recordEducation/recordEducationEdit";
import { RecordEducationListItems } from "../recordEducation/recordEducationListItems";
import { IReportParameterValue } from "../report/reportParameterValue";
import { ReportGenerated2 } from "../report/reportGenerated2";
import { ReportItems } from "../report/reportItems";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { AbortDictionary, getApiCall, getFileApiCall, postApiCall } from "./tokenService";
import { ModuleUnits } from "../unit/moduleUnits";
import { IPagePanel } from "../common/pagePanel";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { SaveSuccessItems } from "ui/Scripts/source/models/common/saveSuccessItems";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { RecordFamiliarizationEdit } from "../recordFamiliarization/recordFamiliarizationEdit";
import { RecordFamiliarizationListItems } from "../recordFamiliarization/recordFamiliarizationListItems";
import { RecordExpiredFamiliarizationListItems } from "../record/recordExpiredFamiliarizationListItems";
import { RecordFurtherEducationEdit } from "../recordFurtherEducation/recordFurtherEducationEdit";
import { FrontToDoItems } from "../front/frontToDoItems";
import { RecordUserRemoveType } from "ui/Scripts/source/models/enums";
import { RecordFurtherEducationGroupEdit } from "../recordFurtherEducationGroup/recordFurtherEducationGroupEdit";
import { RecordFurtherEducationGroupNodes } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNodes";
import { UnitModuleSaveResult } from "../unit/unitModuleSaveResult";
import { ModulePartnerListItems } from "../modulePartner/modulePartnerListItems";
import { ModulePartnerEdit } from "../modulePartner/modulePartnerEdit";
import { CompanyListItems } from "../company/companyListItems";
import { UserListItems } from "../user/userListItems";
import { RecordUserSettings } from "../record/recordUserSettings";

//Abort
const commonAborts = new AbortDictionary();
const reportAborts = new AbortDictionary();
const statisticAborts = new AbortDictionary();
    
//Page & List
export const getRecordPage = (): Promise<RecordPage> => {
    return getApiCall("api/record", RecordPage);
};

export const getRecordPageUnitsAndJobTitles = (companyId: string): Promise<RecordPageUnitsAndJobTitles> => {
    return getApiCall("api/record/pageunitsandjobtitles?id=" + companyId, RecordPageUnitsAndJobTitles);
};

export const getRecordListItems = (companyId: string, pageSize: number, page: number, filter: string, employeeTypes: number[], jobTitles: string[], unitIds: string[],
    activityState: number, sortColumn: string, sortOrderIsAsc: boolean, requireSheetType: boolean = false): Promise<RecordListItems> => {
    reportAborts.abortAll();
    statisticAborts.abortAll();
    return postApiCall("api/record/list", RecordListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        employeeTypes,
        jobTitles,
        unitIds,
        activityState,
        requireSheetType
    }));
};

// #region SheetDataRow
export const addSheetDataRowToRecords = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/addsheetdatarowtorecords", SaveSuccess, JSON.stringify(obj));
};
// #endregion SheetDataRow

// #region Familiarization
export const getExpiredRecordUserFamiliarizationListItems = (companyId: string, employeeTypes: number[], jobTitles: string[], unitIds: string[], activityState: number, pageSize: number, page: number, sortColumn: string, sortOrderIsAsc: boolean, isReport: boolean): Promise<RecordExpiredFamiliarizationListItems> => {
    reportAborts.abortAll();
    return postApiCall("api/record/expiredfamiliarizationlist", RecordExpiredFamiliarizationListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        isReport,
        employeeTypes,
        jobTitles,
        unitIds,
        activityState
    }));
};

export const archiveRecordUserFamiliarizations = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/archivefamiliarizations", SaveSuccess, JSON.stringify(obj));
};
// #endregion Familiarization

// #region FurtherEducation
export const addFurtherEducationToRecords = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/addfurthereducationtorecords", SaveSuccess, JSON.stringify(obj));
};

export const getExpiredRecordUserFurtherEducationListItems = (companyId: string, employeeTypes: number[], jobTitles: string[], unitIds: string[], activityState: number, pageSize: number, page: number, sortColumn: string, sortOrderIsAsc: boolean, isReport: boolean): Promise<RecordExpiredFurtherEducationListItems> => {
    reportAborts.abortAll();
    return postApiCall("api/record/expiredfurthereducationlist", RecordExpiredFurtherEducationListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        isReport,
        employeeTypes,
        jobTitles,
        unitIds,
        activityState
    }));
};

export const archiveRecordUserFurtherEducations = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/archivefurthereducations", SaveSuccess, JSON.stringify(obj));
};
// #endregion FurtherEducation

// #region TransferredProperty
export const addTransferredPropertyToToRecords = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/addtransferredpropertytorecords", SaveSuccess, JSON.stringify(obj));
};
// #endregion TransferredProperty

// #region Qualification
export const addQualificationToToRecords = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/addqualificationtorecords", SaveSuccess, JSON.stringify(obj));
};
// #endregion Qualification

// #region Familiarization
export const addFamiliarizationToToRecords = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/addfamiliarizationtorecords", SaveSuccess, JSON.stringify(obj));
};
// #endregion Familiarization

// #region Dashboard
export const saveRecordPanels = (panels: IPagePanel[]): Promise<ApiSuccess> => {
    return postApiCall("api/record/savepanels", ApiSuccess, JSON.stringify({ panels }));
};

export const getRecordToDoItems = (companyId: string): Promise<FrontToDoItems> => {
    const operationId = "getRecordToDoItems" + (companyId ?? "");
    statisticAborts.abort(operationId);
    return getApiCall("api/record/todoitems?id=" + (companyId ?? ""), FrontToDoItems, (id: string) => {
        statisticAborts.add(operationId, id);
    }).finally(() => {
        statisticAborts.remove(operationId);
    });
};
// #endregion Dashboard

// #region Report
export const getRecordPageReportItems = (companyId: string): Promise<ReportItems> => {
    const operationId = "getRecordPageReportItems" + (companyId ?? "");
    commonAborts.abort(operationId);
    return getApiCall("api/record/reports?id=" + (companyId ?? ""), ReportItems, (id: string) => {
        commonAborts.add(operationId, id);
    }).finally(() => {
        commonAborts.remove(operationId);
    });
};

export const getReportGenerated = (companyId: string, reportId: string, reportName: string, employeeTypes: number[],
    jobTitles: string[], unitIds: string[], activityState: number, parameterValues: IReportParameterValue[], printRows: number[] = []): Promise<ReportGenerated2> => {
    reportAborts.abortAll();
    return postApiCall("api/record/createreport", ReportGenerated2, JSON.stringify({
        companyId,
        reportId,
        reportName,
        employeeTypes,
        jobTitles,
        unitIds,
        activityState,
        parameterValues,
        printRows
    }), (id: string) => {
        reportAborts.add(reportId, id);
    }).finally(() => {
        reportAborts.remove(reportId);
    });
};
// #endregion Report

// #region Edit
export const getRecordEditNew = (companyId: string): Promise<RecordEditNew> => {
    return getApiCall("api/record/new?id=" + companyId, RecordEditNew);
};

export const saveRecordEditNew = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/newsave", SaveSuccess, JSON.stringify(obj));
};

export const getRecordEdit = (recordId: string, companyId: string): Promise<RecordEdit> => {
    return getApiCall("api/record/edit?id=" + recordId + "&companyId=" + companyId, RecordEdit);
};

export const saveRecordEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeRecord = (recordId: string, companyId: string, removeType: RecordUserRemoveType): Promise<ApiSuccess> => {
    return postApiCall("api/record/remove?id=" + recordId + "&companyId=" + companyId + "&removeType=" + removeType.toString(10), ApiSuccess);
};

export const getRecordPrint = (recordId: string, companyId: string): Promise<string> => {
    return getFileApiCall("api/record/print?id=" + recordId + "&companyId=" + companyId);
};
// #endregion Edit

// #region Edit SheetData
export const recordEditSaveSheetData = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsavesheetdata", SaveSuccess, JSON.stringify(obj));
};
// #endregion Edit SheetData

// #region Edit Attachment
export const recordEditRemoveAttachments = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremoveattachments", ApiSuccess, JSON.stringify(obj));
};

export const recordEditAddAttachments = (obj: any): Promise<SaveSuccessItems> => {
    return postApiCall("api/record/editaddattachments", SaveSuccessItems, JSON.stringify(obj));
};
// #endregion Edit Attachment

// #region Edit Familiarization
export const recordEditRemoveFamiliarizations = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremovefamiliarizations", ApiSuccess, JSON.stringify(obj));
};

export const recordEditSaveFamiliarization = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsavefamiliarization", SaveSuccess, JSON.stringify(obj));
};

export const getFamiliarizationTrainers = (companyId: string): Promise<string[]> => {
    return getApiCall("api/record/familiarizationtrainers?id=" + companyId, null);
};
// #endregion Edit Familiarization

// #region Familiarization Handlers
export const approveFamiliarization = (companyId: string, recordUserFamiliarizationId: string, userCode: string): Promise<ApiSuccess> => {
    return postApiCall("api/record/familiarizationapprove", ApiSuccess, JSON.stringify({ companyId, recordUserFamiliarizationId, userCode }));
};

export const getFamiliarizationHandlersSelectUserListItems = (companyId: string, recordUserFamiliarizationId: string, unitId: string, userCode: string, pageSize: number, page: number, filter: string,
    ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, doNotIgnoreRecordUserConnectedUserCode: string,
    sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/record/selectfamiliarizationhandlers", UserListItems, JSON.stringify({
        companyId,
        recordUserFamiliarizationId,
        unitId,
        userCode,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserIds,
        ignoreUserCodes,
        ignoreRecordUserConnected,
        doNotIgnoreRecordUserConnectedUserCode,
        activityState
    }));
};

export const familiarizationEditAddHandlers = (companyId: string, recordUserFamiliarizationId: string, userCode: string, userCodes: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/record/editaddfamiliarizationhandlers", ApiSuccess, JSON.stringify({
        companyId,
        recordUserFamiliarizationId,
        userCode,
        userCodes
    }));
};

export const familiarizationEditRemoveHandlers = (companyId: string, recordUserFamiliarizationId: string, userCode: string, userCodes: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremovefamiliarizationhandlers", ApiSuccess, JSON.stringify({
        companyId,
        recordUserFamiliarizationId,
        userCode,
        userCodes
    }));
};
// #endregion Familiarization Handlers

// #region Edit FurtherEducation
export const recordEditRemoveFurtherEducations = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremovefurthereducations", ApiSuccess, JSON.stringify(obj));
};

export const recordEditSaveFurtherEducation = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsavefurthereducation", SaveSuccess, JSON.stringify(obj));
};
// #endregion Edit FurtherEducation

// #region Edit Employment
export const recordEditRemoveEmployments = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremoveemployments", ApiSuccess, JSON.stringify(obj));
};

export const recordEditSaveEmployment = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsaveemployment", SaveSuccess, JSON.stringify(obj));
};
// #endregion Edit Employment

// #region Edit TransferredProperty
export const recordEditRemoveTransferredProperties = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremovetrensferredproperties", ApiSuccess, JSON.stringify(obj));
};

export const recordEditSaveTransferredProperty = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsavetransferredproperty", SaveSuccess, JSON.stringify(obj));
};

export const getTransferredPropertyTypes = (companyId: string): Promise<string[]> => {
    return getApiCall("api/record/transferredpropertytypes?id=" + companyId, null);
};
// #endregion Edit TransferredProperty

// #region Edit Qualification
export const recordEditRemoveQualifications = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/editremovequalifications", ApiSuccess, JSON.stringify(obj));
};

export const recordEditSaveQualification = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/editsavequalification", SaveSuccess, JSON.stringify(obj));
};
// #endregion Edit Qualification

// #region Edit Log
export const getRecordEditItemLogListItems = (companyId: string, recordId: string, userCode: string, filter: string, pageSize: number, page: number, sortColumn: string, sortOrderIsAsc: boolean): Promise<RecordEditItemLogListItems> => {
    return postApiCall("api/record/editLogList", RecordEditItemLogListItems, JSON.stringify({
        companyId,
        id: recordId,
        userCode: userCode || "",
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
    }));
};
// #endregion Edit Log

// #region Module permissions
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/record/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module permissions

// #region Module settings
export const getRecordUserSettings = (companyId: string): Promise<RecordUserSettings> => {
    return getApiCall("api/record/module/settings/edit?id=" + companyId, RecordUserSettings);
};

export const saveRecordUserSettings = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/settings/save", SaveSuccess, JSON.stringify(obj));
};
// #endregion Module settings

// #region Module basic educations
export const getBasicEducationListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<RecordEducationListItems> => {
    return postApiCall("api/record/module/basiceducation/list", RecordEducationListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getRecordBasicEducationEdit = (companyId: string, userId: string): Promise<RecordEducationEdit> => {
    return getApiCall("api/record/module/basiceducation/edit?id=" + userId + "&companyId=" + companyId, RecordEducationEdit);
};

export const saveRecordBasicEducationEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/basiceducation/save", SaveSuccess, JSON.stringify(obj));
};

export const removeRecordBasicEducations = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/basiceducation/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module basic educations

// #region Module further educations
export const getRecordFurtherEducationGroupNodes = (companyId: string): Promise<RecordFurtherEducationGroupNodes> => {
    return postApiCall("api/record/module/furthereducation/list", RecordFurtherEducationGroupNodes, JSON.stringify({
        companyId
    }));
};

export const getRecordFurtherEducationEdit = (companyId: string, userId: string): Promise<RecordFurtherEducationEdit> => {
    return getApiCall("api/record/module/furthereducation/edit?id=" + userId + "&companyId=" + (companyId ?? ""), RecordFurtherEducationEdit);
};

export const saveRecordFurtherEducationEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/furthereducation/save", SaveSuccess, JSON.stringify(obj));
};

export const removeRecordFurtherEducations = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/furthereducation/remove", ApiSuccess, JSON.stringify(obj));
};

export const getRecordFurtherEducationGroupEdit = (companyId: string, userId: string): Promise<RecordFurtherEducationGroupEdit> => {
    return getApiCall("api/record/module/furthereducationgroup/edit?id=" + userId + "&companyId=" + (companyId ?? ""), RecordFurtherEducationGroupEdit);
};

export const saveRecordFurtherEducationGroupEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/furthereducationgroup/save", SaveSuccess, JSON.stringify(obj));
};

export const removeRecordFurtherEducationGroup = (companyId: string, id: string): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/furthereducationgroup/remove?id=" + id + "&companyId=" + (companyId ?? ""), ApiSuccess);
};
// #endregion Module further educations

// #region Module familiarizations
export const getRecordFamiliarizationListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<RecordFamiliarizationListItems> => {
    return postApiCall("api/record/module/familiarization/list", RecordFamiliarizationListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getRecordFamiliarizationEdit = (companyId: string, userId: string): Promise<RecordFamiliarizationEdit> => {
    return getApiCall("api/record/module/familiarization/edit?id=" + userId + "&companyId=" + companyId, RecordFamiliarizationEdit);
};

export const saveRecordFamiliarizationEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/familiarization/save", SaveSuccess, JSON.stringify(obj));
};

export const removeRecordFamiliarizations = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/familiarization/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module familiarizations

// #region Module units
export const getUnits = (companyId: string): Promise<ModuleUnits> => {
    return getApiCall("api/record/module/units?id=" + companyId, ModuleUnits);
};

export const saveUnits = (obj: any): Promise<UnitModuleSaveResult> => {
    return postApiCall("api/record/module/saveunits", UnitModuleSaveResult, JSON.stringify(obj));
};
// #endregion Module units

// #region RecordUserPartners
export const getRecordUserPartnerListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<ModulePartnerListItems> => {
    return postApiCall("api/record/module/partner/list", ModulePartnerListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getRecordUserPartnerEdit = (companyId: string, eventPartnerId: string): Promise<ModulePartnerEdit> => {
    return getApiCall("api/record/module/partner/edit?id=" + eventPartnerId + "&companyId=" + companyId, ModulePartnerEdit);
};

export const saveRecordUserPartnerEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/record/module/partner/save", SaveSuccess, JSON.stringify(obj));
};

export const removeRecordUserPartner = (companyId: string, id: string, code: string): Promise<ApiSuccess> => {
    return postApiCall("api/record/module/partner/remove", ApiSuccess, JSON.stringify({
        companyId,
        id,
        code
    }));
};

export const getSelectPartnerCompaniesListItems = (pageSize: number, page: number, filter: string, companyGroupIds: string[], activityState: number, sortColumn: string, sortOrderIsAsc: boolean, ignoreCompanyGroupId: string, ignoreCompanyIds: string[]): Promise<CompanyListItems> => {
    return postApiCall("api/record/module/partner/selectcompanieslist", CompanyListItems, JSON.stringify({
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        companyGroupIds,
        activityState,
        ignoreCompanyGroupId,
        ignoreCompanyIds
    }));
};
// #endregion RecordUserPartners